import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  margin-top: 3rem;
  text-align: center;

  h3 {
    font-size: 1.4rem;
    margin-bottom: 1.5rem;
    color: #222;
  }
`;

const Tabela = styled.table`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  border-collapse: collapse;
  border: 1px solid #eee;

  th, td {
    border: 1px solid #ddd;
    padding: 0.9rem;
    font-size: 1rem;
    color: #444;
  }

  th {
    background-color: #f0f4f8;
    font-weight: 600;
  }

  td {
    text-align: center;
  }
`;

const Legenda = styled.p`
  font-size: 0.85rem;
  color: #777;
  margin-top: 1rem;
`;

const Contato = styled.a`
  color: #0077cc;
  font-weight: 600;
  text-decoration: underline;

  &:hover {
    color: #005fa3;
  }
`;


const planos = [
  { cotas: 1, total: 118.8, desconto: 0 },
  { cotas: 2, total: 225.8, desconto: 11.8 },
  { cotas: 3, total: 328.1, desconto: 28.3 },
  { cotas: 4, total: 427.7, desconto: 47.5 },
  { cotas: 5, total: 522.7, desconto: 71.3 },
  { cotas: 6, total: 605.8, desconto: 106.92 },
];

const TabelaPlanosCotas = () => {
  return (
    <Wrapper>
      <h3>Planos para ativar anúncios de múltiplas cotas</h3>
      <Tabela>
        <thead>
          <tr>
            <th>Cotas</th>
            <th>Valor total (12 meses)</th>
            <th>Equivalente mensal</th>
            <th>Desconto aplicado</th>
          </tr>
        </thead>
        <tbody>
          {planos.map((plano) => (
            <tr key={plano.cotas}>
              <td>{plano.cotas} cota{plano.cotas > 1 ? 's' : ''}</td>
              <td>R$ {plano.total.toFixed(2)}</td>
              <td>R$ {(plano.total / 12).toFixed(2)}/mês</td>
              <td>
                {plano.desconto > 0
                  ? `R$ ${plano.desconto.toFixed(2)}`
                  : "—"}
              </td>
            </tr>
          ))}
          <tr>
            <td colSpan={4} style={{ textAlign: "center", paddingTop: "1rem" }}>
              Tem mais de 6 cotas?{" "}
              <Contato href="https://wa.me/message/H7PTB2XYZUDAO1" target="_blank">
                Fale conosco para um plano especial
              </Contato>
            </td>
          </tr>
        </tbody>
      </Tabela>
      <Legenda>* Os valores são únicos e válidos por 12 meses.</Legenda>
    </Wrapper>
  );
};

export default TabelaPlanosCotas;
